import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPreview = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_1407_14034",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 10,
			height: 10,
			children: /* @__PURE__ */ _jsx("rect", {
				x: .840088,
				y: .840088,
				width: 8.32,
				height: 8.32,
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_1407_14034)",
			children: /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M6.431 0.906179C6.25239 0.98391 6.1834 1.10181 6.1834 1.32933C6.1834 1.48019 6.2254 1.54393 6.53001 1.85541L6.87663 2.20985L5.99568 3.09585C5.26323 3.83253 5.11473 4.00436 5.11473 4.11505C5.11473 4.21761 5.18764 4.32114 5.43199 4.56558C5.90183 5.03574 5.84528 5.05754 6.90753 3.99576L7.79522 3.10845L8.14086 3.46112C8.44966 3.77619 8.50509 3.81375 8.66079 3.81375C8.88088 3.81375 9.04304 3.70878 9.10712 3.52482C9.18638 3.29739 9.17314 1.33881 9.09104 1.14216C8.97274 0.858852 8.87475 0.838164 7.66094 0.840209C6.84615 0.841604 6.54186 0.857922 6.431 0.906179ZM3.09167 6.0004L2.20723 6.88529L1.85717 6.53504C1.54606 6.22374 1.4877 6.18473 1.33316 6.18473C0.883253 6.18473 0.840088 6.315 0.840088 7.67325C0.840088 8.55637 0.852958 8.7712 0.91285 8.8871C1.0396 9.13233 1.18573 9.16009 2.35015 9.16009C3.67934 9.16009 3.81376 9.11499 3.81376 8.66915C3.81376 8.51829 3.77175 8.45456 3.46714 8.14307L3.12052 7.78864L4.00147 6.90263C4.73392 6.16595 4.88242 5.99413 4.88242 5.88343C4.88242 5.78088 4.80952 5.67734 4.56516 5.4329C4.09486 4.96228 4.15066 4.9408 3.09167 6.0004Z",
				fill: "#545F7E"
			})
		})
	]
});
const ForwardRef = forwardRef(SvgPreview);
export default ForwardRef;
